/*
 * @Description:
 * @Author:  bean^ <bean_4@163.com>
 * @Date: 2020-10-09 15:47:29
 * @LastEditors: bean
 * @LastEditTime: 2022-03-17 15:00:54
 */
import Vuex from 'vuex'
import Vue from "vue"
import app from '../utils/app'

Vue.use(Vuex)

const rockArray = (array, item) => {
  const index = array.findIndex(e => e === item)
  if (index === -1) return array
  const newArray = JSON.parse(JSON.stringify(array))
  newArray.splice(index, 1)
  newArray.splice((~~(array.length / 2)), 0, item)
  return newArray
}


const getState = () => ({
  carId: '',
  carConfig: {},
  interArr: [],
  colorArr: [],
  selectTypeId: '',
  selectColorCode: '',
  selectInterCode: '',
  showType: 'outer',
  hasInit: false
})


const state = getState()

const getters = {
  selectTypeItem(state) {
    return (state.carConfig.typeArr || []).find(ele => ele.code === state.selectTypeId) || {}
  }
}
const actions = {
  resetState({state}) {
    const newState = getState()
    for (const newStateKey in newState) {
      state[newStateKey] = newState[newStateKey]
    }
  },

  initStore({state, dispatch}, _car) {
    dispatch('resetState')

    let car = _car.toLowerCase().replaceAll(' ', '').includes('nx400h') ? 'nx400h' : _car.split(' ')[0].toLowerCase()

    return requireJson(`${car}.json`).then(carConfig => {
      console.log(carConfig)
      const {defaultType, typeArr} = carConfig
      state.carId = car
      state.carConfig = carConfig

      const queryType = typeArr.find(type => {
        const {name, describe, subDescribe} = type
        // dockingCode: 用来匹配无法通过 name, describe, subDescribe 识别到的车型
        return ((type.dockingCode || [name, describe, subDescribe].join('').replaceAll(' ', '').toLowerCase()) === _car.replaceAll(' ', '').toLowerCase())
      })

      const queryTypeCode = queryType ? queryType.code : undefined

      // dispatch('setSelectTypeId', defaultType || typeArr[0].code)
      dispatch('setSelectTypeId', queryTypeCode || defaultType || typeArr[0].code)
    })
  },
  setShowType({getters, state, dispatch}, type) {
    // if (state.showType != type) {
    state.showType = type;
    if (type === 'inter' && getters.selectTypeItem.interDisSelect) {
      dispatch('setSelectTypeId', state.carConfig.defaultType)
    }
    if (type == 'outer') {
      app.back_to_origin()
    } else {
      app.changeInterior(state.selectInterCode, state.hasInit)
      app.goto_paraPos()
    }
    // }
  },
  setSelectTypeId({state, dispatch, getters}, code) {
    const {
      typeArr,
      defaultInterCode: classDefaultInterCode,
      defaultColorCode: classDefaultColorCode
    } = state.carConfig
    state.selectTypeId = code;
    const {defaultInterCode, defaultColorCode, interArr, colorArr, name, describe, subDescribe}
        = getters.selectTypeItem
    console.log('setSelectTypeId=====', interArr,)
    app.changeCarConfiguration(code, state.hasInit)

    let defaultInter = defaultInterCode || classDefaultInterCode
    if (!interArr.includes(defaultInter)) defaultInter = interArr[0]

    dispatch('setSelectInterCode', {
      code: defaultInter,
      array: interArr
    })
    let defaultColor = defaultColorCode || classDefaultColorCode
    if (!colorArr.includes(defaultColor)) defaultColor = colorArr[0]
    dispatch('setSelectColorCode', {
      code: defaultColor,
      array: colorArr
    })
    console.log('changeCarConfiguration', code)
    window._CAR_ = [name, describe, subDescribe].join(' ')
  },
  setSelectInterCode({state}, data) {
    const {code, array} = typeof data === 'string' ? {code: data} : data

    state.selectInterCode = code
    if (array) {
      state.interArr = rockArray(array, code)
    }
    console.log('changeInterior', code)
    app.changeInterior(code, state.hasInit)
  },
  setSelectColorCode({state}, data) {
    const {code, array} = typeof data === 'string' ? {code: data} : data
    state.selectColorCode = code
    if (array) {
      state.colorArr = rockArray(array, code)
    }
    console.log('changeOutward', code)
    app.changeOutward(code, state.hasInit)
  },

  setAppState({state}) {
    const {selectColorCode, selectTypeId, selectInterCode} = state
    app.changeCarConfiguration(selectTypeId, state.hasInit)
    app.changeOutward(selectColorCode, state.hasInit)
    app.changeInterior(selectInterCode, state.hasInit)
  }
}

const mutations = {
  setInitState(state, type) {
    state.hasInit = type
  }
}
const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
})
export default store
